// Navbar.js
import React, { useState, useEffect } from 'react';
import './navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Toggle menu function
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu when a link is clicked
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Prevent body scroll when menu is open on mobile
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    // Cleanup function
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [menuOpen]);

  // Handle escape key to close menu
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false);
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
<a href="/" className="navbar-logo">
  <div className="logo-icon" aria-label="Lions Club Logo">
    <img src='/Lions Club of Colombo Eye Care.png' alt="Lions Club of Colombo Eye Care Logo" />
  </div>
  <div className="logo-text">
    <span className="logo-main">LIONS CLUB</span>
    <span className="logo-sub">Colombo Eye Care</span>
  </div>
</a>
          {/* Mobile Menu Icon (Hamburger) */}
          <button 
            className={`menu-icon ${menuOpen ? 'open' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Navigation Menu */}
          <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <a href="/" className="nav-link" onClick={closeMenu}>Home</a>
            </li>
            <li className="nav-item">
              <a href="/aboutus" className="nav-link" onClick={closeMenu}>About Us</a>
            </li>
            <li className="nav-item">
              <a href="/gallery" className="nav-link" onClick={closeMenu}>Gallery</a>
            </li>
            <li className="nav-item">
              <a href="/contactus" className="nav-link" onClick={closeMenu}>Contact Us</a>
            </li>
            <li className="nav-item">
              <a href="/get-involved-today" className="nav-link" onClick={closeMenu}>Get Involved</a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Overlay when menu is open on mobile */}
      <div 
        className={`nav-overlay ${menuOpen ? 'active' : ''}`} 
        onClick={closeMenu}
        aria-hidden="true"
      />
    </>
  );
}

export default Navbar;

